import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { renderTableTitle } from "@/utils/render.jsx";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
import { getDownstreamAlertCandidates, getDownstreamAlertsPage, manualBindDownstreamAlert, repushDownstreamAccounts } from "@/service/sync-manage";
import { formatTime, joinNames, systemName } from "./sync-utils";
const SUPPORTED_SYSTEMS = ["UC", "IHOTEL", "ICATER"];
const MULTIPLE_MATCH_TYPE = "MULTIPLE_MATCHED";
const UNIT_CODE_NOT_MATCHED_TYPE = "UNIT_CODE_NOT_MATCHED";
const MISMATCH_ALERT_TYPES = [UNIT_CODE_NOT_MATCHED_TYPE];
const MULTIPLE_ALERT_PAGE_SIZE = 500;
const UNIT_MISMATCH_TYPE = UNIT_CODE_NOT_MATCHED_TYPE;
export default {
  name: "sync-alerts-tab",
  components: {
    OverflowTooltipText
  },
  props: {
    appId: {
      type: String,
      default: ""
    },
    unitCode: {
      type: String,
      default: ""
    },
    downstreamOptions: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      alertRows: [],
      multipleAlertRows: [],
      systemPageMap: {},
      multiplePage: {
        totalRows: 0
      },
      groupStates: {},
      batchRetryConfirm: {
        visible: false,
        saving: false,
        group: null
      },
      candidateModal: {
        visible: false,
        saving: false,
        row: null,
        candidates: [],
        selectedKey: ""
      }
    };
  },
  computed: {
    querySystems() {
      const configuredSystems = this.downstreamOptions.map(item => item.value).filter(Boolean);
      return [...new Set([...configuredSystems, ...SUPPORTED_SYSTEMS])];
    },
    alertEntries() {
      return this.buildAlertEntries(this.alertRows);
    },
    multipleEntries() {
      return this.buildAlertEntries(this.multipleAlertRows);
    },
    mismatchEntries() {
      return this.alertEntries.filter(item => item.alertType !== MULTIPLE_MATCH_TYPE);
    },
    multipleRows() {
      return this.multipleEntries.filter(item => item.alertType === MULTIPLE_MATCH_TYPE);
    },
    mismatchTotal() {
      const totalRows = this.querySystems.reduce((total, system) => {
        return total + this.mismatchSystemTotal(system);
      }, 0);
      return totalRows || this.mismatchEntries.length;
    },
    multipleTotal() {
      return Math.max(this.multiplePage.totalRows || 0, this.multipleRows.length);
    },
    alertTotalCount() {
      return this.mismatchTotal + this.multipleTotal;
    },
    candidateWarningText() {
      const row = this.candidateModal.row || {};
      const downstreamSystem = row._downstreamSystem || row.downstreamSystem;
      return $t("mwzkz73u", "${this.shortSystemName(downstreamSystem)} \u4E2D\u5B58\u5728 ${this.candidateModal.candidates.length} \u4E2A\u540C\u540D\u8D26\u53F7\u300C${row.userName || \"\u2014\"}\u300D\uFF0C\u65E0\u6CD5\u81EA\u52A8\u552F\u4E00\u786E\u5B9A\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u8D26\u53F7\u8FDB\u884C\u5173\u8054\u3002", {
        "this.shortSystemName(downstreamSystem)": this.shortSystemName(downstreamSystem),
        "this.candidateModal.candidates.length": this.candidateModal.candidates.length,
        "row.userName || \"\u2014\"": row.userName || "—"
      });
    },
    mismatchGroups() {
      const groupMap = {};
      this.mismatchEntries.forEach(item => {
        const key = `${item.unitCode || "-"}__${item.downstreamSystem}`;
        if (!groupMap[key]) {
          groupMap[key] = {
            key,
            unitCode: item.unitCode || "—",
            downstreamSystem: item.downstreamSystem,
            totalRows: this.mismatchSystemTotal(item.downstreamSystem),
            rows: []
          };
        }
        groupMap[key].rows.push(item);
      });
      return Object.values(groupMap).map(group => ({
        ...group,
        totalRows: group.totalRows || group.rows.length
      })).sort((prev, next) => `${prev.unitCode}-${prev.downstreamSystem}`.localeCompare(`${next.unitCode}-${next.downstreamSystem}`));
    },
    mismatchColumns() {
      return [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: $t("h5542", "成员"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userName",
        minWidth: 150,
        render: (h, {
          row
        }) => this.memberNode(h, row)
      }, {
        title: $t("pgxs2", "部门"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "departments",
        minWidth: 180,
        render: (h, {
          row
        }) => this.departmentNode(h, row)
      }, {
        title: $t("f6ql714", "用户代码"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userCode",
        minWidth: 150,
        render: (h, {
          row
        }) => this.mutedTextNode(h, row.userCode)
      }, {
        title: $t("3vjwpoa", "iWork 单位代码"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "unitCode",
        minWidth: 180,
        render: (h, {
          row
        }) => this.tableTextNode(h, row.unitCode, "alert-code-text")
      }, {
        title: $t("dcms504", "暂挂起始"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "suspendStartTime",
        minWidth: 150,
        render: (h, {
          row
        }) => this.mutedTextNode(h, this.formatShortTime(row.suspendStartTime))
      }, {
        title: $t("dcge154", "暂挂时长"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "suspendDuration",
        minWidth: 150,
        render: (h, {
          row
        }) => this.tableTextNode(h, this.durationText(row), "alert-duration-text")
      }];
    },
    multipleColumns() {
      return [{
        title: $t("h5542", "成员"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userName",
        minWidth: 150,
        render: (h, {
          row
        }) => this.memberNode(h, row)
      }, {
        title: $t("pgxs2", "部门"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "departments",
        minWidth: 180,
        render: (h, {
          row
        }) => this.departmentNode(h, row)
      }, {
        title: $t("f6ql714", "用户代码"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userCode",
        minWidth: 160,
        render: (h, {
          row
        }) => this.mutedTextNode(h, row.userCode)
      }, {
        title: $t("b3k0px4", "匹配依据"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "matchBasis",
        minWidth: 150,
        render: (h, {
          row
        }) => this.tableTextNode(h, row.matchBasis, "alert-match-basis", {
          display: "inline-block",
          width: "auto",
          maxWidth: "100%",
          boxSizing: "border-box",
          verticalAlign: "middle"
        })
      }, {
        title: $t("ffv07x4", "目标系统"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "downstreamSystem",
        minWidth: 150,
        render: (h, {
          row
        }) => this.renderMultipleTargetSystems(h, row)
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "action",
        width: 150,
        render: (h, {
          row
        }) => this.manualSelectButtonNode(h, row)
      }];
    }
  },
  watch: {
    mismatchGroups() {
      this.syncGroupStates();
    }
  },
  methods: {
    refresh(reset = false) {
      return this.loadAlerts(reset);
    },
    // 头部刷新图标只重拉当前告警页数据，不重置分页和已选状态，避免用户操作上下文丢失。
    refreshAlertPage() {
      if (this.loading) return;
      return this.refresh(false);
    },
    buildAlertEntries(rows) {
      const entries = [];
      rows.forEach((row, rowIndex) => {
        const accounts = row.alertType === MULTIPLE_MATCH_TYPE ? this.multipleTargetAccounts(row) : this.targetAccounts(row);
        accounts.forEach((account, accountIndex) => {
          const downstreamSystem = account.downstreamSystem || row.downstreamSystem || row._querySystem || "";
          if (!downstreamSystem || !this.isAlertAccount(row, account)) return;
          // 多重匹配数据已在接口层限定，避免这里再被 lastMessage 改判。
          const alertType = row.alertType === MULTIPLE_MATCH_TYPE ? MULTIPLE_MATCH_TYPE : this.inferAlertType(row, account) || UNIT_MISMATCH_TYPE;
          entries.push(this.buildAlertEntry(row, account, downstreamSystem, alertType, `${rowIndex}-${accountIndex}`));
        });
      });
      return this.uniqueEntries(entries);
    },
    // 告警页按 downstreamSystems 分别查询，确保行级重试/绑定能拿到明确目标系统。
    async loadAlerts(reset = false) {
      if (!this.unitCode) {
        this.alertRows = [];
        this.multipleAlertRows = [];
        this.systemPageMap = {};
        this.multiplePage = {
          totalRows: 0
        };
        this.groupStates = {};
        this.emitAlertCount();
        return;
      }
      this.loading = true;
      try {
        await Promise.all([...this.querySystems.map(system => {
          var _this$systemPageMap$s;
          return this.fetchMismatchSystem(system, {
            page: 1,
            pageSize: reset ? 10 : ((_this$systemPageMap$s = this.systemPageMap[system]) === null || _this$systemPageMap$s === void 0 ? void 0 : _this$systemPageMap$s.pageSize) || 10
          });
        }), this.fetchMultipleAlerts()]);
        this.syncGroupStates(reset);
        this.emitAlertCount();
      } finally {
        this.loading = false;
      }
    },
    // 告警处理页签打开时，父级角标应以本页真实告警数据为准，而不是总览缓存。
    emitAlertCount() {
      this.$emit("alert-count-change", this.alertTotalCount);
    },
    // 每个下游系统卡片独立带服务端分页，翻页只刷新对应 downstreamSystems。
    async fetchMismatchSystem(system, {
      page,
      pageSize
    }) {
      const oldPageState = this.systemPageMap[system] || {};
      this.$set(this.systemPageMap, system, {
        ...oldPageState,
        page,
        pageSize,
        loading: true
      });
      try {
        var _data$retVal, _data$retVal2;
        const {
          data
        } = await getDownstreamAlertsPage({
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystems: [system],
          alertTypes: MISMATCH_ALERT_TYPES,
          firstResult: (page - 1) * pageSize,
          pageSize
        });
        const datas = (data === null || data === void 0 ? void 0 : data.result) === 0 ? (((_data$retVal = data.retVal) === null || _data$retVal === void 0 ? void 0 : _data$retVal.datas) || []).map(item => ({
          ...item,
          _querySystem: system
        })) : [];
        this.alertRows = this.alertRows.filter(item => item._querySystem !== system).concat(datas);
        this.$set(this.systemPageMap, system, {
          page,
          pageSize,
          loading: false,
          totalRows: (data === null || data === void 0 || (_data$retVal2 = data.retVal) === null || _data$retVal2 === void 0 ? void 0 : _data$retVal2.totalRows) || 0
        });
      } catch (error) {
        this.$set(this.systemPageMap, system, {
          ...oldPageState,
          page,
          pageSize,
          loading: false
        });
        throw error;
      }
    },
    // 多重匹配单独按 MULTIPLE_MATCHED 拉取，避免混入单位代码未匹配卡片。
    async fetchMultipleAlerts() {
      const {
        data
      } = await getDownstreamAlertsPage({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystems: this.querySystems,
        alertTypes: [MULTIPLE_MATCH_TYPE],
        firstResult: 0,
        pageSize: MULTIPLE_ALERT_PAGE_SIZE
      });
      if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
        var _data$retVal3, _data$retVal4;
        this.multipleAlertRows = (((_data$retVal3 = data.retVal) === null || _data$retVal3 === void 0 ? void 0 : _data$retVal3.datas) || []).map(item => {
          var _item$downstreamAccou;
          return {
            ...item,
            // 该接口已通过 alertTypes 固定限定为多重匹配，这里直接补齐类型，避免后续二次推断误过滤。
            alertType: MULTIPLE_MATCH_TYPE,
            _querySystem: item.downstreamSystem || ((_item$downstreamAccou = item.downstreamAccounts) === null || _item$downstreamAccou === void 0 || (_item$downstreamAccou = _item$downstreamAccou[0]) === null || _item$downstreamAccou === void 0 ? void 0 : _item$downstreamAccou.downstreamSystem) || ""
          };
        });
        this.multiplePage = {
          totalRows: ((_data$retVal4 = data.retVal) === null || _data$retVal4 === void 0 ? void 0 : _data$retVal4.totalRows) || 0
        };
      } else {
        this.multipleAlertRows = [];
        this.multiplePage = {
          totalRows: 0
        };
      }
    },
    // 同步每个分组自己的分页和选择状态，避免刷新数据后旧 key 残留。
    syncGroupStates(reset = false) {
      const nextStates = {};
      this.mismatchGroups.forEach(group => {
        const oldState = this.groupStates[group.key] || {};
        const pageSize = reset ? 10 : oldState.pageSize || 10;
        const pageCount = Math.max(Math.ceil(group.rows.length / pageSize), 1);
        nextStates[group.key] = {
          page: reset ? 1 : Math.min(oldState.page || 1, pageCount),
          pageSize,
          selectedKeys: reset ? [] : oldState.selectedKeys || [],
          loading: false
        };
      });
      this.groupStates = nextStates;
    },
    targetAccounts(row) {
      const querySystem = row._querySystem;
      const accounts = Array.isArray(row.downstreamAccounts) ? row.downstreamAccounts : [];
      const filteredAccounts = querySystem ? accounts.filter(item => !item.downstreamSystem || item.downstreamSystem === querySystem) : accounts;
      if (filteredAccounts.length) return filteredAccounts;
      return [{
        downstreamSystem: querySystem || row.downstreamSystem || (Array.isArray(row.downstreamSystems) ? row.downstreamSystems[0] : "")
      }];
    },
    multipleTargetAccounts(row) {
      const accounts = Array.isArray(row.downstreamAccounts) ? row.downstreamAccounts : [];
      // 多重匹配列表按未绑定目标系统平铺，一名成员多个 lastMessage=MULTIPLE_MATCHED 系统时拆成多行展示。
      const accountMap = accounts.reduce((map, account) => {
        if (account.lastMessage === "MULTIPLE_MATCHED" && account.downstreamSystem) {
          map.set(account.downstreamSystem, account);
        }
        return map;
      }, new Map());
      if (accountMap.size) {
        return [...accountMap.values()];
      }
      return this.targetAccounts(row);
    },
    isAlertAccount(row, account) {
      const type = this.inferAlertType(row, account);
      if (type) return true;
      return account.latestUnacked || account.bound === false || account.lastResult === "FAILED" || row.alertType || row.alertStatus;
    },
    inferAlertType(row, account) {
      if (row.alertType === MULTIPLE_MATCH_TYPE) {
        return MULTIPLE_MATCH_TYPE;
      }
      const lastMessage = String(account.lastMessage || row.lastMessage || "").toUpperCase();
      // 单位未匹配仍以后端 lastMessage 为准；多重匹配来源已由接口层固定。
      if (lastMessage === MULTIPLE_MATCH_TYPE) {
        return MULTIPLE_MATCH_TYPE;
      }
      return UNIT_MISMATCH_TYPE;
    },
    buildAlertEntry(row, account, downstreamSystem, alertType, fallbackKey) {
      const candidateCount = this.firstNumber(account, ["candidateCount", "matchedCount", "sameNameCount"]);
      const suspendStartTime = account.lastAckTime || row.lastAckTime || "";
      const unitCode = account.unitCode || row.iworkUnitCode || row.unitCode || this.unitCode || "—";
      return {
        ...row,
        _rawRow: row,
        _account: account,
        _downstreamSystem: downstreamSystem,
        _alertKey: [row.openId, row.userCode, unitCode, downstreamSystem, alertType, fallbackKey].filter(Boolean).join("__"),
        alertType,
        downstreamSystem,
        unitCode,
        userName: row.userName || account.userName || "—",
        userCode: row.userCode || account.userCode || "—",
        mobile: row.mobile || account.mobile || "",
        departments: row.departments || account.departments || [],
        suspendStartTime,
        candidateCount: candidateCount === null ? 0 : candidateCount,
        matchBasis: row.matchBasis || account.matchBasis || $t("ptnpix6", "姓名（回退）")
      };
    },
    uniqueEntries(entries) {
      const cache = new Set();
      return entries.filter(item => {
        if (cache.has(item._alertKey)) return false;
        cache.add(item._alertKey);
        return true;
      });
    },
    firstNumber(source, fields) {
      for (const field of fields) {
        if (source[field] !== undefined && source[field] !== null) {
          const numberValue = Number(source[field]);
          return Number.isFinite(numberValue) ? numberValue : 0;
        }
      }
      return null;
    },
    firstValue(source, fields) {
      for (const field of fields) {
        if (source[field]) return source[field];
      }
      return "";
    },
    // 单位未匹配统计直接使用接口返回 totalRows，避免对多重匹配再做二次减法。
    mismatchSystemTotal(system) {
      var _this$systemPageMap$s2;
      return ((_this$systemPageMap$s2 = this.systemPageMap[system]) === null || _this$systemPageMap$s2 === void 0 ? void 0 : _this$systemPageMap$s2.totalRows) || 0;
    },
    groupState(group) {
      const pageState = this.systemPageMap[group.downstreamSystem] || {};
      const groupState = this.groupStates[group.key] || {};
      return {
        page: pageState.page || 1,
        pageSize: pageState.pageSize || 10,
        totalRows: group.totalRows || group.rows.length,
        selectedKeys: groupState.selectedKeys || [],
        loading: pageState.loading || groupState.loading || false
      };
    },
    groupPageRows(group) {
      const state = this.groupState(group);
      const selectedSet = new Set(state.selectedKeys || []);
      return group.rows.map(item => ({
        ...item,
        _checked: selectedSet.has(item._alertKey)
      }));
    },
    groupPageCount(group) {
      const state = this.groupState(group);
      return Math.max(Math.ceil(state.totalRows / state.pageSize), 1);
    },
    async changeGroupPage(group, page) {
      const state = this.groupState(group);
      const pageCount = this.groupPageCount(group);
      await this.fetchMismatchSystem(group.downstreamSystem, {
        page: Math.min(Math.max(page, 1), pageCount),
        pageSize: state.pageSize
      });
      this.syncGroupStates(true);
    },
    async changeGroupPageSize(group, pageSize) {
      await this.fetchMismatchSystem(group.downstreamSystem, {
        page: 1,
        pageSize
      });
      this.syncGroupStates(true);
    },
    onGroupSelectionChange(group, selection) {
      const state = this.groupState(group);
      const nextKeys = new Set(state.selectedKeys || []);
      this.groupPageRows(group).forEach(item => nextKeys.delete(item._alertKey));
      selection.forEach(item => nextKeys.add(item._alertKey));
      this.$set(this.groupStates, group.key, {
        ...state,
        selectedKeys: [...nextKeys]
      });
    },
    togglePageSelection(group, checked) {
      const state = this.groupState(group);
      const nextKeys = new Set(state.selectedKeys || []);
      this.groupPageRows(group).forEach(item => {
        if (checked) {
          nextKeys.add(item._alertKey);
        } else {
          nextKeys.delete(item._alertKey);
        }
      });
      this.$set(this.groupStates, group.key, {
        ...state,
        selectedKeys: [...nextKeys]
      });
    },
    isPageAllChecked(group) {
      const rows = this.groupPageRows(group);
      if (!rows.length) return false;
      const selectedSet = new Set(this.groupState(group).selectedKeys || []);
      return rows.every(item => selectedSet.has(item._alertKey));
    },
    isPageIndeterminate(group) {
      const rows = this.groupPageRows(group);
      const selectedSet = new Set(this.groupState(group).selectedKeys || []);
      const selectedCount = rows.filter(item => selectedSet.has(item._alertKey)).length;
      return selectedCount > 0 && selectedCount < rows.length;
    },
    selectedCount(group) {
      return (this.groupState(group).selectedKeys || []).length;
    },
    isGroupLoading(group) {
      return this.groupState(group).loading;
    },
    setGroupLoading(group, loading) {
      const state = this.groupState(group);
      this.$set(this.groupStates, group.key, {
        ...state,
        loading
      });
    },
    // 批量重试先走二次确认，确认后仍然复用现有批量重试接口和参数。
    openBatchRetryConfirm(group) {
      if (!group || this.isGroupLoading(group)) return;
      this.batchRetryConfirm = {
        visible: true,
        saving: false,
        group: {
          key: group.key,
          unitCode: group.unitCode,
          downstreamSystem: group.downstreamSystem,
          totalRows: group.totalRows,
          rows: group.rows
        }
      };
    },
    closeBatchRetryConfirm() {
      if (this.batchRetryConfirm.saving) return;
      this.batchRetryConfirm = {
        visible: false,
        saving: false,
        group: null
      };
    },
    // 二次确认按钮点击后直接调用现有批量重试逻辑，不改变后端接口行为。
    async confirmBatchRetry() {
      const group = this.batchRetryConfirm.group;
      if (!group) return;
      this.batchRetryConfirm.saving = true;
      try {
        await this.retryRows(group, group.rows, true, "ALERTS");
      } finally {
        this.batchRetryConfirm.saving = false;
        this.batchRetryConfirm.group = null;
        this.batchRetryConfirm.visible = false;
      }
    },
    // 重试成功后清空当前卡片选中状态，避免旧选择继续显示或误触发二次重试。
    clearGroupSelection(group) {
      const state = this.groupState(group);
      this.$set(this.groupStates, group.key, {
        ...state,
        selectedKeys: []
      });
    },
    retrySelectedRows(group) {
      const selectedSet = new Set(this.groupState(group).selectedKeys || []);
      const rows = group.rows.filter(item => selectedSet.has(item._alertKey));
      return this.retryRows(group, rows);
    },
    // 告警处理重试统一只提示“提交成功/提交失败”，不再透传后端 msg，避免页面文案不一致。
    retryResultPayload(data, success) {
      var _data$result;
      const message = success ? $t("cx7dr74", "提交成功") : $t("cx66zs4", "提交失败");
      return {
        ...data,
        result: success ? 0 : (_data$result = data === null || data === void 0 ? void 0 : data.result) !== null && _data$result !== void 0 ? _data$result : -1,
        retVal: {
          ...((data === null || data === void 0 ? void 0 : data.retVal) || {}),
          message
        },
        msg: message
      };
    },
    // 批量重试按文档要求固定传空 userCodes；告警处理弹窗确认时再补固定 scope，避免影响单条重试。
    async retryRows(group, rows, forceEmptyUserCodes = false, scope = "") {
      if (this.isGroupLoading(group)) return;
      const userCodes = forceEmptyUserCodes ? [] : [...new Set(rows.map(item => item.userCode))].filter(Boolean);
      if (!forceEmptyUserCodes && !userCodes.length) return;
      this.setGroupLoading(group, true);
      try {
        const requestData = {
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystem: group.downstreamSystem,
          userCodes
        };
        if (scope) {
          requestData.scope = scope;
        }
        const response = await repushDownstreamAccounts(requestData);
        const data = response === null || response === void 0 ? void 0 : response.data;
        const success = (data === null || data === void 0 ? void 0 : data.result) === 0;
        this.$emit("operation-result", this.retryResultPayload(data, success));
        if (success) {
          this.clearGroupSelection(group);
        }
      } finally {
        this.setGroupLoading(group, false);
      }
    },
    // 候选账号查询只打开选择弹窗，不能自动选择或提交第一个候选项。
    async openCandidates(row) {
      const downstreamSystem = (row === null || row === void 0 ? void 0 : row._downstreamSystem) || (row === null || row === void 0 ? void 0 : row.downstreamSystem);
      if (!downstreamSystem || !row) {
        this.$Message.warning($t("t1qqda8", "请先选择下游系统"));
        return;
      }
      const {
        data: {
          result,
          retVal
        }
      } = await getDownstreamAlertCandidates({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem,
        users: [{
          openId: row.openId,
          userCode: row.userCode
        }]
      });
      if (result === 0) {
        var _retVal$results;
        const resultRow = (retVal === null || retVal === void 0 || (_retVal$results = retVal.results) === null || _retVal$results === void 0 ? void 0 : _retVal$results[0]) || {};
        this.candidateModal = {
          visible: true,
          saving: false,
          row,
          candidates: resultRow.candidates || [],
          selectedKey: ""
        };
      }
    },
    candidateKey(item, index) {
      return [item.downstreamUserKey || "", item.downstreamUserCode || "", index].join("__");
    },
    candidateAccountName(item) {
      return item.downstreamUserCode || item.userName || "—";
    },
    candidateDepartmentName(item) {
      return item.departmentName || item.departmentCode || "—";
    },
    // 候选账号创建时间展示完整年月日时分秒，便于人工确认同名账号。
    candidateCreateDate(value) {
      return formatTime(value);
    },
    // 人工绑定提交管理员选择的候选账号，候选 key 为空时按文档回退提交账号代码。
    async manualBind() {
      const row = this.candidateModal.row;
      const candidate = this.candidateModal.candidates.find((item, index) => this.candidateKey(item, index) === this.candidateModal.selectedKey);
      const downstreamSystem = (row === null || row === void 0 ? void 0 : row._downstreamSystem) || (row === null || row === void 0 ? void 0 : row.downstreamSystem);
      if (!candidate) {
        this.$Message.warning($t("ui2p207", "请选择候选账号"));
        return;
      }
      if (!row || !downstreamSystem) return;
      this.candidateModal.saving = true;
      try {
        const {
          data
        } = await manualBindDownstreamAlert({
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystem,
          openId: row.openId,
          userCode: row.userCode,
          downstreamUserKey: candidate.downstreamUserKey,
          downstreamUserCode: candidate.downstreamUserCode
        });
        this.$emit("operation-result", data);
        if ((data === null || data === void 0 ? void 0 : data.result) === 0) {
          this.candidateModal.visible = false;
        }
        // await this.loadAlerts();
      } finally {
        this.candidateModal.saving = false;
      }
    },
    // 表格各列共用真实宽度检测，避免仅靠固定字符数判断多语言文本是否应显示 Tooltip。
    tableTextNode(h, text, textClass = "", textStyle = {}) {
      const value = text === null || text === undefined || text === "" ? "—" : String(text);
      return h(OverflowTooltipText, {
        props: {
          text: value,
          maxWidth: 300,
          textClass,
          tooltipClass: "alert-table-text-tooltip",
          tooltipStyle: {
            display: "block",
            width: "100%",
            minWidth: 0,
            marginTop: "5px"
          },
          textStyle
        }
      });
    },
    // 成员列仅展示姓名，并复用单行省略避免超长姓名撑高表格行。
    memberNode(h, row) {
      return this.tableTextNode(h, row.userName, "alert-member-text", {
        color: "#111827",
        fontSize: "12px",
        fontWeight: 700
      });
    },
    departmentNode(h, row) {
      const department = joinNames(row.departments);
      if (!department || department === "—") {
        return this.mutedTextNode(h, "—");
      }
      return this.tableTextNode(h, department, "alert-department-text");
    },
    // 操作按钮随语言变化可能变长，限制可见宽度并复用溢出检测，仅在文字被截断时展示完整提示。
    manualSelectButtonNode(h, row) {
      return h("div", {
        class: "alert-manual-select-action"
      }, [h("Button", {
        class: "alert-manual-select-button",
        props: {
          size: "small"
        },
        style: {
          maxWidth: "150px"
        },
        on: {
          click: () => this.openCandidates(row)
        }
      }, [h(OverflowTooltipText, {
        props: {
          text: $t("wjwmk26", "手动选择账号"),
          maxWidth: 300,
          textClass: "alert-manual-select-button-text",
          tooltipClass: "alert-manual-select-tooltip",
          tooltipStyle: {
            display: "block",
            width: "100%",
            minWidth: 0
          }
        }
      })])]);
    },
    mutedTextNode(h, text) {
      return this.tableTextNode(h, text, "alert-muted-text");
    },
    shortSystemName(system) {
      const names = {
        UC: "UC",
        IHOTEL: "iHotel",
        ICATER: "iCater"
      };
      return names[system] || systemName(system);
    },
    systemPillClass(system) {
      return {
        UC: "alert-system-pill--uc",
        IHOTEL: "alert-system-pill--hotel",
        ICATER: "alert-system-pill--cater"
      }[system];
    },
    renderMultipleTargetSystems(h, row) {
      const system = row._downstreamSystem || row.downstreamSystem;
      if (!system) {
        return this.mutedTextNode(h, "—");
      }
      return this.tableTextNode(h, this.shortSystemName(system), `sync-log-system-tag ${system.toLowerCase()}`, {
        display: "inline-block",
        width: "auto",
        maxWidth: "100%",
        boxSizing: "border-box",
        verticalAlign: "middle"
      });
    },
    formatShortTime(value) {
      if (!value) return "—";
      const formatted = formatTime(value);
      return formatted.length >= 16 ? formatted.slice(5, 16) : formatted;
    },
    durationText(row) {
      if (!row.suspendStartTime) return "—";
      const time = new Date(String(row.suspendStartTime).replace(/-/g, "/"));
      if (Number.isNaN(time.getTime())) return "—";
      const hours = Math.max(Math.round((Date.now() - time.getTime()) / 1000 / 60 / 60), 1);
      if (hours <= 48) {
        return $t("o8y1egd", "\u7EA6 ${hours} \u5C0F\u65F6", {
          "hours": hours
        });
      }
      return $t("hqwu1bs", "\u7EA6 ${Math.ceil(hours / 24)} \u5929", {
        "Math.ceil(hours / 24)": Math.ceil(hours / 24)
      });
    }
  }
};